<script lang="ts">
import { defineComponent, h, type VNode } from 'vue';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';
import ClientAccessChip from '@/bundles/Contact/components/chips/ClientAccessChip.vue';

export default defineComponent({
  name: 'ContactMemberChip',

  props: {
    // A client-access member only sees the occupiers their contact is granted
    // (SCBT-82) — rendering them as plain "Member" is misleading.
    // Not `isClient`: across the app that name is the signed-in user's role flag
    // (`useUserRoles`), not the role of the member this chip renders.
    client: Boolean,
  },

  render (): VNode {
    // Both branches render a single root, so a parent-supplied class falls through on its own.
    if (this.client) {
      return h(ClientAccessChip);
    }

    return h(CommonChip, { color: 'primary' }, { default: () => [
      h('span', 'Member'),
    ] });
  },
});
</script>
